var _path, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 11.3461 1.74609 9.6 3.9 9.6H29.64C31.7939 9.6 33.54 11.3461 33.54 13.5V48.6C33.54 50.7539 31.7939 52.5 29.64 52.5H3.9C1.74609 52.5 0 50.7539 0 48.6V13.5Z",
    fill: "url(#paint0_linear_32930_23634)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_32930_23634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2173 2.28266C52.5943 4.65957 52.5943 8.51331 50.2173 10.8902L45.9302 15.1774L27.7386 33.3689C26.7636 34.344 25.5419 35.0357 24.2041 35.3701L17.2321 37.1132C16.1177 37.3918 15.1082 36.3823 15.3868 35.2679L17.1299 28.2959C17.4643 26.9581 18.156 25.7364 19.1311 24.7614L37.3226 6.56983L41.6098 2.28266C43.9867 -0.0942551 47.8404 -0.0942551 50.2173 2.28266Z",
    fill: "url(#paint1_linear_32930_23634)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_32930_23634)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1254 10.7983C52.4516 8.47215 52.4516 4.70073 50.1254 2.37458C47.7993 0.048437 44.0278 0.048437 41.7017 2.37458L19.223 24.8533C18.2646 25.8117 17.5847 27.0125 17.256 28.3274L15.513 35.2994C15.2582 36.3186 16.1814 37.2418 17.2005 36.987L24.1726 35.244C25.4875 34.9153 26.6883 34.2354 27.6467 33.277L50.1254 10.7983ZM50.2173 10.8902C52.5943 8.51331 52.5943 4.65957 50.2173 2.28266C47.8404 -0.0942551 43.9867 -0.0942551 41.6098 2.28266L19.1311 24.7614C18.156 25.7364 17.4643 26.9581 17.1299 28.2959L15.3868 35.2679C15.1082 36.3823 16.1177 37.3918 17.2321 37.1132L24.2041 35.3701C25.5419 35.0357 26.7636 34.344 27.7386 33.3689L50.2173 10.8902Z",
    fill: "url(#paint2_linear_32930_23634)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0911 35.286C17.9445 35.5831 16.9005 34.5391 17.1976 33.3925C17.499 32.2293 18.9503 31.8339 19.8 32.6836C20.6496 33.5333 20.2543 34.9846 19.0911 35.286Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_32930_23634",
    x: -14.66,
    y: -29.5,
    width: 96.66,
    height: 96.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32930_23634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_32930_23634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_32930_23634",
    x: -14.66,
    y: -29.5,
    width: 96.66,
    height: 96.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32930_23634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_32930_23634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32930_23634",
    x1: 0,
    y1: 31.05,
    x2: 33.54,
    y2: 31.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#FBCBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C48A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#945B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32930_23634",
    x1: -1.36733,
    y1: 9.80913,
    x2: 70.382,
    y2: 46.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104415,
    stopColor: "#313F67",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415705,
    stopColor: "#5389BB",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917188,
    stopColor: "#81C1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32930_23634",
    x1: -1.36733,
    y1: 9.80913,
    x2: 70.382,
    y2: 46.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104415,
    stopColor: "#313F67",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415705,
    stopColor: "#5389BB",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917188,
    stopColor: "#81C1E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorIcon);
export default __webpack_public_path__ + "static/media/InvestorIcon.7377cd76e497fc87392c9e9afaa71f98.svg";
export { ForwardRef as ReactComponent };